export const COMPONENT_NAME = 'Carousel MultiCardCarousel';
